export { default as LogIn } from './LogIn';
export { default as Register } from './Register';
export { default as Sso } from './Sso';
export { default as LogOut } from './LogOut';



// WEBPACK FOOTER //
// ./src/features/authentification/index.js